import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useConfirmCancelEditOption = () => {
  const { t } = useTranslation();
  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t(
        'transaction_items.detail.options.drawer.edit.cancel_confirm.title'
      ),
      body: t(
        'transaction_items.detail.options.drawer.edit.cancel_confirm.message'
      ),
      cancelButtonProps: {
        isTertiary: true,
        children: t(
          'transaction_items.detail.options.drawer.edit.cancel_confirm.button.return'
        ),
        testId:
          'transaction_items.detail.options.drawer.edit.cancel_confirm.button.return',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t(
          'transaction_items.detail.options.drawer.edit.cancel_confirm.button.cancel'
        ),
        testId:
          'transaction_items.detail.options.drawer.edit.cancel_confirm.button.cancel',
      },
    }),
    [t]
  );
  return useConfirmModal(args);
};
